import { InjectionToken } from '@angular/core';

export interface FeaturesConfig {
  readonly clickedEvent: boolean;
  readonly debugWeb: boolean;
}

export const FEATURES_CONFIG = new InjectionToken<FeaturesConfig>('FEATURES_CONFIG');
